import { render, staticRenderFns } from "./FilterLabel.vue?vue&type=template&id=66a30b7f&scoped=true"
import script from "./FilterLabel.vue?vue&type=script&lang=js"
export * from "./FilterLabel.vue?vue&type=script&lang=js"
import style0 from "./FilterLabel.vue?vue&type=style&index=0&id=66a30b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a30b7f",
  null
  
)

export default component.exports